document.addEventListener('DOMContentLoaded', function () {
  const section = document.getElementById('shopify-section-template--19193732300851__dual_tiles_4pyyVA');
  if (!section || window.innerWidth < 750) return;

  const blocks = section.querySelectorAll('.section-dual-tiles__block');
  blocks.forEach(block => {
    const content = block.querySelector('.section-dual-tiles__content');
    if (!content) return;
    block.style.position = 'relative';
    content.style.position = 'sticky';
    content.style.top = '30vh';
    content.style.zIndex = '1';
  });
});
